import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "@/store";

export const useDepositStoresFilterState = () => {
  const filterState = useSelector(
    (state: ApplicationState) => state.filterDepositStores,
  );
  return useMemo(() => filterState, [filterState]);
};
